import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HakoTextArea, {
      modelValue: _ctx.answer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answer) = $event))
    }, null, 8, ["modelValue"])
  ]))
}